import React from 'react';
import "./ourworksSlider.css";
import OurworksSlider from "./ourworksSlider.js";

const OurWork = () => {
  return ( 
    <>  
      <div id="works" className="relative py-8 mb-10 ">
        <h1 id="" className="font-semibold mx-auto text-center xl:text-5xl lg:text-4xl sm:text-3xl">من أعمالنا</h1>
        <div className="absolute right-[45%] left-[45%] mt-[20px] border-t-[5px] border-[#FBD675]"></div>
      </div>

      <div className="m-auto relative justify-center max-w-[1353px]">
        <div className="mx-12">
          <img src="assets/images/بطاقات الأعمال.svg" className="object-fill  h-fit w-[1353px]"/>
        </div>
      </div> 

      <div id="works-slid">
        <OurworksSlider />
      </div> 
    </>
  )
}

export default OurWork;